import React from 'react'
import { Box } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { Link } from 'react-router-dom';
import reception from "../assets/Images/0G2A9034.jpg"
import shape from "../assets/Images/shapes/SHAPE 001-01.png"
export default function AboutCompany() {
  return (
    <div id="about-company">
      <div data-aos="fade-up" className='pt-[88px] md:pt-[240px] overflow-hidden' >
        <div className='max-w-[1340px] mx-auto relative'>
          <div className='relative'>
            <div className='relative z-[1]'>
              <Box sx={{ flexGrow: 1 }} >
                <Grid container spacing={13} sx={{
                  flexDirection: {
                    xs: "column-reverse",
                    md: "column-reverse",
                    lg: "row",
                  },
                }}
                  className='flex justify-center items-center lg:flex-col flex-col-reverse'>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <div className='w-full xl:w-[632px]  flex justify-center items-center'>
                      <img src={reception} loading="eager"
                        alt="Medical Atteintion" className='rounded-[24px] xl:h-[480px]' />
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <div>
                      <h2 className='font-heading leading-[1.138em] text-[36px] lg:text-[58px] text-thickGreen  mb-6'>The Vision That Led Foundation Of MagnAid Hospital</h2>
                      <p className='mb-[16px] lg:mb-[32px] text-paraGreen font-body font-medium leading-[1.667em] text-[18px]'>The vision to make healthcare facilities available to everyone irrespective of financial status sparked the idea to lead a foundation for MagnAid Hospitals. Equipped with advanced technologies, driven with compassionate care for the wellness of the society to shape a healthier future.</p>
                      <div>
                        <Link to='#value' className='border border-thickGreen bg-transparent text-thickGreen px-7 py-6 rounded-full hover:bg-orange  font-body text-[20px] leading-[1.112em] 
       transition-all hover:duration-300  hover:text-white hover:border-none font-medium  hover:bg-opacity-90 
       hover:translate-y-[-3px] block md:inline-block text-center mr-[0] md:mr-[24px]' onClick={(e) => {
                            e.preventDefault();
                            document.querySelector('#value')?.scrollIntoView({
                              behavior: 'smooth'
                            });
                          }}>Our Values</Link>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </div>
            <div>
              <img src={shape} alt="shape" className='absolute inline-block w-[79%] md:top-[35%] lg:top-[-15%] left-[-23.5%]' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
